function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import { StyledReviewCardsReviewsComponentDesktopComponent } from "./review-cards-reviews-component.scss";
import DefaultProps from "./default-props";
import { ReviewCardsReviewsComponentMobileComponent } from "./review-cards-reviews-mobile-component/review-cards-reviews-mobile-component";
import ReviewCardComponent from "./review-card-reviews-component/review-card-reviews-component";
const ReviewCardsReviewsComponentDesktopComponent = (props)=>{
    const { fullParagraph, marginAboveCards, cards, spaceFromParagraph, topicBottomMargin, buttonTopMargin, titleSize, textSize } = props;
    const fullParagraphAdvancedProps = {
        spaceFromParagraph,
        topicBottomMargin,
        buttonTopMargin,
        titleSize,
        textSize
    };
    return /*#__PURE__*/ _jsxs(StyledReviewCardsReviewsComponentDesktopComponent, {
        className: "review-cards-reviews-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "paragraph",
                children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraph, fullParagraphAdvancedProps))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "cards",
                style: {
                    marginTop: marginAboveCards
                },
                children: cards === null || cards === void 0 ? void 0 : cards.map((card, index)=>/*#__PURE__*/ _jsx(ReviewCardComponent, {
                        reviewCardProps: card
                    }, index))
            })
        ]
    });
};
const ReviewCardsReviewsComponent = withResponsiveHOC(ReviewCardsReviewsComponentDesktopComponent, ReviewCardsReviewsComponentMobileComponent);
ReviewCardsReviewsComponent.defaultProps = DefaultProps;
export default ReviewCardsReviewsComponent;
